// extracted by mini-css-extract-plugin
export default {"headerWrapper":"HeaderSection_headerWrapper__6inGh","headerSection":"HeaderSection_headerSection__D05KG","cardsRow":"HeaderSection_cardsRow__qdp70"};